'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThumbnail = undefined;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var getThumbnail = exports.getThumbnail = function getThumbnail(videoDetails) {
  var thumbnails = (0, _get2['default'])(videoDetails, 'snippet.thumbnails');
  var thumbnail = '';

  if (thumbnails) {
    var max = (0, _get2['default'])(thumbnails, 'maxres.url');
    var high = (0, _get2['default'])(thumbnails, 'high.url');
    var medium = (0, _get2['default'])(thumbnails, 'medium.url');
    var standard = (0, _get2['default'])(thumbnails, 'default.url');
    thumbnail = max || high || medium || standard;
  }

  return thumbnail;
};